<template>
  <div id="settingWrap_home">
    <a-layout>
      <div class="workshopHeader">
        <a-row :class="handleScrollTop ? 'headerContainScroll' : 'headerContain'" ref="headerContain">
          <a-col :span="5"></a-col>
          <a-col :span="13" class="workshopHeader_msg">
            <h2>{{attInfo.attTitle}}</h2>
            <div class="workshopHeader_data">
              <a-row type="flex">
                <a-col :span="8">
                  <span>批改形式：</span>
                  <span v-if="attInfo.checkType == 'auto'">自动批改</span>
                  <span v-if="attInfo.checkType == 'manual'">手动批改</span>
                  <span v-if="attInfo.checkType == ''">未设置</span>
                </a-col>
                <a-col :span="8" class="queNum">
                  <span>题目数量：</span>
                  <span>{{attInfo.assignmentCount}}</span>
                </a-col>
              </a-row>
            </div>
          </a-col>
          <a-col :span="6" style="display: flex;align-items: flex-end;justify-content: flex-end;padding: 0 40px 20px 0">
            <div class="btnGroups">
              <a-button @click="backCouserwork()">返回</a-button>
            </div>
          </a-col>
        </a-row>
      </div>
      <a-layout>
        <a-layout-sider width="240" :class="handleScrollTop ? 'sidebarScroll' : 'sidebar'" :style="{ position: 'fixed', borderRight: '2px solid #E9E9E9' }" ref="sidebar">
          <a-menu :defaultSelectedKeys="['/settingWrap']" :selectedKeys="[fullPath]" mode="inline" :style="{ height: '100vh', borderRight: 0 }">
            <a-menu-item :key="'/settingWrap'">
              <router-link :to="{ path: '/settingWrap' }">
                <a-icon type="home" />
                <span>作业设置</span>
              </router-link>
            </a-menu-item>
            <a-menu-item :key="'/settingWrap/questionSetting'">
              <router-link :to="{ path: '/settingWrap/questionSetting' }">
                <a-icon type="sound" />
                <span>题目设置</span>
              </router-link>
            </a-menu-item>
          </a-menu>
        </a-layout-sider>
        <a-layout-content :style="{ marginLeft: '240px', background: '#fff', minHeight: 'calc(100vh - 164px)' }">
          <router-view></router-view>
          <div style="height: 200px;" v-if="contentBottom"></div>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>

<script>
// import { Icon } from 'ant-design-vue';
// const IconFont = Icon.createFromIconfontCN({
//   scriptUrl: require('../../../static/js/iconfont.js')
// });
export default {
  // components: {
  //   IconFont
  // },
  data(){
    return {
      handleScrollTop: false,
      contentBottom: false,
      groupInfo: {},
      gruopNum: {},
      fullPath: '',
      attinfoId: '',
      attInfo: {}
    };
  },
  created () {
    this.attinfoId = this.appUtils.getCourseInfo().attinfoId;
    this.getOneAttInfo();
    this.fullPath = this.$route.fullPath;
  },
  mounted () {
    var that = this;
    window.onscroll = function(){
      that.handleScroll();
    };
  },
  updated () {
    this.fullPath = this.$route.fullPath;
  },
  methods: {
    backCouserwork(){
      this.$router.push({path: '/courseworkSetting'});
    },
    getOneAttInfo(){
      let url = this.apis.coursework.getOneAttInfoById + this.attinfoId;
      this.http.get(url)
      .then((res)=>{
        this.attInfo = res.data;
        // this.$store.dispatch('setCourseInfoFunction', res.data);
      }).catch((err)=> {
        console.log(err);
      });
    },
    handleScroll(){
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 0) {
        this.handleScrollTop = true;
        this.contentBottom = true;
      } else {
        this.handleScrollTop = false;
        this.contentBottom = false;
      }
    }
  }
};
</script>

<style lang="less">
#settingWrap_home {
  &>*{
    box-sizing: border-box;
  }
  .ant-layout-header{
    background: #fff;
  }
  .ant-layout-sider {
    background: #fff;
  }
  .sidebar {
    max-height: calc(100vh - 215px);
  }
  .sidebarScroll {
    max-height: calc(100vh - 114px);
  }
  .ant-menu{
    text-align: left;
  }
  .workshopHeader{
    background: url('../../../../../static/images/yxHome_bg.png') no-repeat;
    background-size: 100% 100%;
    min-height: 50px;
    .headerContain{
      height: 100px;
      padding-top: 20px;
    }
    .headerContainScroll{
      width: 100%;
      height: 50px;
      position: fixed;
      top: 64px;
      background: #fff;
      padding-top: 10px;
      z-index: 20;
      border-bottom:1px solid rgba(232,232,232,1);
      box-shadow:0px 4px 12px rgba(238,238,238,1);
    }
    .ant-col{
      height: 100%;
    }
    .workshopHeader_msg{
      text-align: left;
      h2{
        height: 30px;
        line-height: 30px;
        font-size: 20px;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        span{
          display: inline-block;
          width:52px;
          height:22px;
          line-height: 22px;
          background:rgba(246,255,237,1);
          border:1px solid rgba(183,235,143,1);
          border-radius:4px;
          font-size: 12px;
          color:rgba(82,196,26,1);
          text-align: center;
          margin-left: 10px;
        }
      }
      h4{
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        color: #666;
      }
      .workshopHeader_data{
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        color: #666;
        .queNum{
          margin-left: 20px;
          span:nth-child(2){
            color: #1890FF;
          }
        }
      }
    }
    .btnGroups{
      .ant-btn{
        margin-left: 17px;
      }
    }
  }
}
</style>
